import React from 'react'
import Lightbox from './Lightbox'

const host = REST_API// "http://localhost:8080"
// const baseUrl = "http://images.cyrillejoubert-talents.com/api/files"
const baseUrl = host + "/api/files"


const ImageBackground = ({src, className="", style={}, ratio=1}) => (
  <div className="ac-image-background">
    <div className={"ac-image-background__image " + className} style={{
      backgroundImage: `url("${src}")`,
      borderRadius: 3,
      ...style
    }} />
     <div style={{width: '100%', paddingBottom: ((100/ratio) + '%')}} />
   </div>
)

export default class ImageGrid extends React.Component {
  
  constructor(props){
    super(props)
    
    this.state = {
      currentImage: 0,
      isOpen: false
    }
    
    this.gotoPrevLightboxImage = () => this.setState({ currentImage: this.state.currentImage-1})
    this.gotoNextLightboxImage = () => this.setState({ currentImage: this.state.currentImage+1})
    this.gotoLightboxImage = (index) => this.setState({ currentImage: index})
    this.closeLightbox = () => this.setState({ isOpen: false })
  }
  
  render(){
    const { images=[], gridSize=4, onClick } = this.props
    const { isOpen, currentImage } = this.state
    // style={{ position: 'absolute', left: 0, top: 0 }}

    const className = gridSize == 4 
      ? "ac-grid-1-4 ac-grid-md-1-2 ac-grid-sm-1-1"
      : "ac-grid-1-2 ac-grid-md-1-1 ac-grid-sm-1-1"

    return (
      <div style={{width: '100%', marginBottom: 20}}>
        <div className="ac-grid">
          {images.map((image, idx) => (
            <div key={idx} className={className} 
            style={{cursor: 'pointer'}} aria-haspopup="true" 
            onClick={() => {
              if (onClick) {
                onClick(idx)
              } else {
                this.setState({
                  isOpen: true,
                  currentImage: idx
                })
              }
            }}>
              <ImageBackground src={baseUrl + "/" + image.id + "/thumbnail?w=240&h=360&auto"} ratio={2/3} />
              {/*<img width="300" height="214" src={image.thumbnail} className="attachment-portfolio-three size-portfolio-three wp-post-image" />*/}
            </div>
          ))}
        </div>
        <Lightbox
          images={images.map(img => ({
            src: baseUrl + "/" + img.id,
            thumbnail: baseUrl + "/" + img.id + "/thumbnail?w=50&h=50&auto&minScale=0.75"
          }))}
          isOpen={isOpen}
          currentImage={currentImage}
          backdropClosesModal={false}
          onClickPrev={this.gotoPrevLightboxImage}
          onClickNext={this.gotoNextLightboxImage}
          onClickThumbnail={this.gotoLightboxImage}
          onClose={this.closeLightbox}
          showThumbnails={true}
          thumbnailOffset={8}
        />

      </div>
    )
  } 
}


/** WEBPACK FOOTER **
 ** ./src/profile/ImageGrid.js
 **/